import React from 'react';
import { Alert, Button } from '@dopomogai/ui';

type Props = {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
};

export function ErrorState({
  title = 'Something went wrong',
  message = 'We couldn’t load your data. Please try again.',
  onRetry,
  className,
}: Props) {
  return (
    <div className={className}>
      <Alert type="error" title={title} message={message} />
      {onRetry && (
        <div className="mt-4">
          <Button variant="secondary" text="Try again" onClick={onRetry} />
        </div>
      )}
    </div>
  );
}
